import { render, staticRenderFns } from "./viewTeamTargets.vue?vue&type=template&id=fc4a8ae8&"
import script from "./viewTeamTargets.vue?vue&type=script&lang=js&"
export * from "./viewTeamTargets.vue?vue&type=script&lang=js&"
import style0 from "./viewTeamTargets.vue?vue&type=style&index=0&id=fc4a8ae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports